import Vue from 'vue'
import media from '@/assets/css/media/media.scss'

export default ({ Mobile, Desktop }) => {
  return Vue.component('render', {
    functional: true,
    render: (h, ctx) => {
      return h(!window.matchMedia(media['media-3']).matches ? Mobile : Desktop, ctx.data, ctx.children)
    }
  })
}
